export enum FormFields {
  /**
   * Переименовал из-за того, что эти значения поставляются в name в инпут,
   * из-за этого в поле для номера телефона предлагает вставить почту
   */
  LoginByPhone = 'phone',
  LoginByEmail = 'email',
}

export interface FormValues {
  [FormFields.LoginByPhone]?: string;
  [FormFields.LoginByEmail]?: string;
}
